/* Squish Monster: countdowns and the bundle picker. No dependencies. */
(() => {
  /* ---------- Advent countdown ---------- */
  // Counts down to Dec 1 (local time). During Dec 1-24 it switches to its "live" copy,
  // and after Christmas Eve it hides itself.
  function adventState(now = new Date()) {
    const year = now.getFullYear();
    const start = new Date(year, 11, 1);
    const end = new Date(year, 11, 25);
    if (now >= end) return { phase: 'over' };
    if (now >= start) return { phase: 'live', door: now.getDate() };
    return { phase: 'before', ms: start - now };
  }

  function renderCountdown(el) {
    const s = adventState();
    const live = el.querySelector('[data-live]');
    const before = el.querySelector('[data-before]');
    if (s.phase === 'over') {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    if (s.phase === 'live') {
      if (before) before.hidden = true;
      if (live) {
        live.hidden = false;
        const door = live.querySelector('[data-door]');
        if (door) door.textContent = s.door;
      }
      return;
    }
    if (live) live.hidden = true;
    if (before) before.hidden = false;
    const totalSec = Math.floor(s.ms / 1000);
    const totalMin = Math.floor(totalSec / 60);
    const days = Math.floor(totalMin / 1440);
    const hours = Math.floor((totalMin % 1440) / 60);
    const mins = totalMin % 60;
    const secs = totalSec % 60;
    el.querySelectorAll('[data-secs]').forEach((n) => (n.textContent = String(secs).padStart(2, '0')));
    el.querySelectorAll('[data-days]').forEach((n) => (n.textContent = days));
    el.querySelectorAll('[data-hours]').forEach((n) => (n.textContent = String(hours).padStart(2, '0')));
    el.querySelectorAll('[data-mins]').forEach((n) => (n.textContent = String(mins).padStart(2, '0')));
    el.querySelectorAll('[data-days-label]').forEach((n) => (n.textContent = days === 1 ? n.dataset.one : n.dataset.many));
  }

  function initCountdowns(root = document) {
    root.querySelectorAll('[data-sm-countdown]').forEach(renderCountdown);
  }

  initCountdowns();
  setInterval(() => initCountdowns(), 1000);
  document.addEventListener('shopify:section:load', (e) => initCountdowns(e.target));

  /* ---------- Bundle picker ---------- */
  // Drives Horizon's native <variant-picker> so price, media, URL and the add-to-cart form
  // all update through the theme's own code path.
  class SmBundlePicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
    }

    onChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.value) return;
      event.stopPropagation();
      this.querySelectorAll('.sm-bundle').forEach((card) => {
        card.classList.toggle('is-selected', card.contains(input));
      });
      const scope =
        this.closest('product-information, featured-product-information, .product-information, section, .shopify-section') ||
        document;
      const native = scope.querySelector(`variant-picker input[data-variant-id="${CSS.escape(input.value)}"]`);
      if (native) {
        if (!native.checked) {
          native.checked = true;
          native.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      // Fallback: point the product form straight at the chosen variant.
      scope.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((idInput) => {
        idInput.value = input.value;
      });
    };
  }

  if (!customElements.get('sm-bundle-picker')) {
    customElements.define('sm-bundle-picker', SmBundlePicker);
  }
})();
